import img1 from "./itens-de-seguranca/holografia.gif"
import img5 from "./itens-de-seguranca/nanotext-decode.png"
import img6 from "./itens-de-seguranca/numismatic-bg.png"
import img3 from "./itens-de-seguranca/qr-code-sob-luz-uv.gif"
import img4 from "./itens-de-seguranca/qr-cripto-ovi.gif"
import { PublicHash } from "./public-hash"
import { QrCodeQueryLoading } from "./qr-code-query-loading"

const images = [img1, "", img3, img4, img5, img6]

import type { ProductConfig } from "../type"
import FavIcon from "./assets/com-fav.png"
import PublicHashSealMask from "./assets/hash-public.webp"
import Logo from "./assets/logo.webp"
import LandingPage from "./LandingPage"
import { SealMask } from "./seal-mask"

export const worldComexxConfig: ProductConfig = {
  product: {
    name: "world-comexx",
    domains: [
      "comexx.primi.com.br",
      "www.comexx.primi.com.br",
      "comexx.homol.primi.com.br",
      "www.comexx.homol.primi.com.br",
    ],
    description:
      "Gerencie os selos de autenticidade do seu produto com numeração sequencial. Cada produto possui seu selo único com controle de lotes numerados.",
  },
  LandingPage,
  Logo,
  SealMask,
  QrCodeQueryLoading,
  PublicHash,
  FavIcon,
  PublicHashSealMask,
  theme: {
    colors: {
      cssVariables: {
        "--primary": "oklch(0.2 0.15 270)",
      },
      fallback: {
        primary: "purple-900",
        secondary: "amber-300",
        accent: "orange-400",
        background: "from-purple-50 to-amber-50",
        cardBackground: "from-amber-50 to-orange-50",
      },
    },
    fonts: {
      heading: "font-bold",
      body: "font-normal",
    },
  },
  securityItems: [
    {
      title: "Holografia de segurança",
      description:
        "A holografia no selo é exclusiva e de alta segurança. Ela deve apresentar alternância entre as palavras “VÁLIDO” , “ORIGINAL” e “OK” e no mesmo padrão de layout do exemplo acima.",
      image: images[0],
    },
    {
      title: "Numeração Microperfurada",
      description:
        "Cada selo possui uma codificação única impressa por um equipamento especial a laser sem uso de tintas, na tonalidade branca. Confira se o código é o mesmo que aparece na validação e se é composto por pequenos furos.",
      image: images[2],
    },
    {
      title: "QR Code variável com brilho sob luz UV",
      description:
        "Quando colocado na luz UV, o QR Code brilha em tons azulados. Isso ajuda a garantir que ele seja verdadeiro e não falsificado.",
      image: images[3],
    },
    {
      title: "QR Code criptografado OVI",
      description:
        "Verifique se o QR Code muda de cor (entre tons verdes e roxos) ao mudar o ângulo de visão do selo. É possível sentir um leve relevo. Essas características, obtidas com tintas de segurança, indicam autenticidade. Um QR Code com cor estática pode sinalizar falsificação.",
      image: images[4],
    },
    {
      title: "Nanotexto com imagem decodificada",
      description:
        "O selo possui textos e imagens tão pequenos que só é possível ver com lupa ou filtro especial. Isso serve para aumentar a segurança e evitar falsificações.",
      image: images[5],
    },
    {
      title: "Fundo numismático",
      description:
        "Os fundos anticópias apresentam padrões variados e complexos, e podem ser constituído por linhas contínuas e bem definidas em formas geométricas variadas. Para garantir que o selo não é uma reprodução, compare o fundo do selo que você está verificando com a imagem de referência acima. Linhas falhas, ou desenhos diferentes, podem ser um indício de fraude.",
      image: images[6],
    },
  ],
  settings: {
    enableQRCode: true,
    enableMap: true,
    enableReports: true,
    enablePublicHash: true,
    maxSealsPerBatch: 5000,
  },
}
